class CampaignPlanningConfirmationModal {
  constructor() {
  }
  
  show() {
    this.main.classList.add('modal--show');
    document.body.classList.add('block-scroll');

    setTimeout(() => {
      this.main.classList.add('modal--anim');
    }, 50);
  }
  
  hide() {
    this.main.classList.remove('modal--anim');

    setTimeout(() => {
      this.main.classList.remove('modal--show');
      document.body.classList.remove('block-scroll');
    }, 750);
  }
}

export default CampaignPlanningConfirmationModal;